export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.39bb4ba7.worker.js");
}
